/**
 * Rewards progress — one bar, two milestones (amounts from IF_FREE_GIFT / data-m1 data-m2).
 */
window.IfCartDelivery = (function () {
  const DEFAULT_M1 = 50000;
  const DEFAULT_M2 = 99900;

  function globalM1() {
    return (window.IF_FREE_GIFT && window.IF_FREE_GIFT.m1) || DEFAULT_M1;
  }

  function globalM2() {
    return (window.IF_FREE_GIFT && window.IF_FREE_GIFT.m2) || DEFAULT_M2;
  }

  function thresholdsFor(el) {
    var m1 = globalM1();
    var m2 = globalM2();
    if (el && el.dataset) {
      if (el.dataset.m1) m1 = parseInt(el.dataset.m1, 10) || m1;
      if (el.dataset.m2) m2 = parseInt(el.dataset.m2, 10) || m2;
    }
    return { m1: m1, m2: m2, m2Label: '₹' + Math.round(m2 / 100) };
  }

  function giftSubCopy(m2Label) {
    return m2Label + ' unlocks a free gift';
  }

  function giftEmptySubCopy(m2Label) {
    return '₹500: free delivery · ' + m2Label + ': free gift';
  }

  function formatMoney(cents) {
    const amount = Math.round(cents / 100);
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0,
      }).format(amount);
    } catch (e) {
      return '₹' + amount.toLocaleString('en-IN');
    }
  }

  function paintTrack(track, progress, m2On) {
    if (!track) return;

    const pct = Math.max(0, Math.min(100, progress));
    track.dataset.progress = String(pct);
    track.style.setProperty('--if-delivery-p', pct + '%');
    track.setAttribute('aria-valuenow', String(pct));
    track.classList.toggle('if-cart-delivery__track--done', m2On);

    if (m2On) {
      track.style.background = 'linear-gradient(90deg, #067d62 0%, #10a37f 100%)';
    } else {
      track.style.background =
        'linear-gradient(90deg, #ff9900 0%, #ffb84d ' +
        pct +
        '%, #e3e6e6 ' +
        pct +
        '%, #e3e6e6 100%)';
    }

    const fill = track.querySelector('.if-cart-delivery__fill');
    if (fill) fill.style.width = m2On ? '100%' : pct + '%';

    let thumb = track.querySelector('.if-cart-delivery__thumb');
    if (pct > 0 && pct < 100 && !m2On) {
      if (!thumb) {
        thumb = document.createElement('span');
        thumb.className = 'if-cart-delivery__thumb';
        thumb.setAttribute('aria-hidden', 'true');
        track.appendChild(thumb);
      }
      thumb.style.left = pct + '%';
    } else if (thumb) {
      thumb.remove();
    }
  }

  function setText(el, html, isHtml) {
    if (!el) return;
    if (isHtml) el.innerHTML = html;
    else el.textContent = html;
  }

  function update(cart) {
    if (!cart) return;

    const total =
      window.IfFreeGift && typeof window.IfFreeGift.payableTotal === 'function'
        ? window.IfFreeGift.payableTotal(cart)
        : cart.total_price || 0;

    document.querySelectorAll('[data-if-cart-delivery]').forEach(function (el) {
      const t = thresholdsFor(el);
      const M1 = t.m1;
      const M2 = t.m2;
      const m2Label = t.m2Label;
      const m1On = total >= M1;
      const m2On = total >= M2;
      const remainingM1 = Math.max(0, M1 - total);
      const remainingM2 = Math.max(0, M2 - total);
      const progress = total <= 0 ? 0 : Math.min(100, Math.round((total / M2) * 100));

      el.classList.toggle('if-cart-delivery--m1', m1On);
      el.classList.toggle('if-cart-delivery--m2', m2On);
      el.classList.toggle('if-cart-delivery--unlocked', m2On);
      el.classList.toggle('if-cart-delivery--empty', total <= 0);
      el.dataset.total = String(total);
      el.dataset.progress = String(progress);

      const title = el.querySelector('.if-cart-delivery__title');
      const sub = el.querySelector('.if-cart-delivery__sub');
      const meter = el.querySelector('.if-cart-delivery__meter');
      const current = el.querySelector('.if-cart-delivery__current');
      const track = el.querySelector('.if-cart-delivery__track');
      const bar = el.querySelector('.if-cart-rewards__bar');
      const scale = el.querySelectorAll('.if-cart-rewards__scale span');
      const goals = el.querySelectorAll('.if-cart-rewards__goal');

      if (bar) bar.style.setProperty('--if-m1-pct', Math.round((M1 / M2) * 1000) / 10 + '%');

      if (scale[1]) scale[1].classList.toggle('is-on', m1On);
      if (scale[2]) {
        scale[2].textContent = m2Label;
        scale[2].classList.toggle('is-on', m2On);
      }
      if (goals[0]) goals[0].classList.toggle('is-on', m1On);
      if (goals[1]) goals[1].classList.toggle('is-on', m2On);

      if (window.IfFreeGift && typeof window.IfFreeGift.paintTiers === 'function') {
        window.IfFreeGift.paintTiers(cart);
      }

      if (total <= 0) {
        if (title) {
          title.textContent = 'Free delivery from ₹500';
          title.classList.remove('if-cart-delivery__title--success');
        }
        if (sub) sub.textContent = giftEmptySubCopy(m2Label);
        if (meter) meter.hidden = true;
        return;
      }

      if (meter) meter.hidden = false;

      if (m2On) {
        if (title) {
          title.textContent = 'All rewards unlocked';
          title.classList.add('if-cart-delivery__title--success');
        }
        if (sub) sub.textContent = 'Free delivery + free gift ready to claim';
      } else if (m1On) {
        if (title) {
          title.textContent = 'Free delivery unlocked';
          title.classList.add('if-cart-delivery__title--success');
        }
        setText(sub, 'Add <strong>' + formatMoney(remainingM2) + '</strong> more for a free gift', true);
      } else {
        if (title) {
          title.classList.remove('if-cart-delivery__title--success');
          title.innerHTML =
            'Add <strong>' +
            formatMoney(remainingM1) +
            '</strong> more for <strong>free delivery</strong>';
        }
        if (sub) sub.textContent = giftSubCopy(m2Label);
      }

      if (current) current.textContent = formatMoney(total);
      paintTrack(track, progress, m2On);
    });
  }

  function paintAllFromDom() {
    document.querySelectorAll('[data-if-cart-delivery]').forEach(function (el) {
      const track = el.querySelector('.if-cart-delivery__track');
      if (!track) return;
      const progress = parseInt(el.dataset.progress || track.dataset.progress || '0', 10);
      const m2On = el.classList.contains('if-cart-delivery--m2');
      paintTrack(track, progress, m2On);
    });
  }

  function refresh() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(update)
      .catch(function () {});
  }

  function syncScaleFromDom() {
    document.querySelectorAll('[data-if-cart-delivery]').forEach(function (el) {
      var t = thresholdsFor(el);
      var scale = el.querySelectorAll('.if-cart-rewards__scale span');
      if (scale[2]) scale[2].textContent = t.m2Label;
      var sub = el.querySelector('.if-cart-delivery__sub');
      if (sub && sub.textContent.indexOf('1000') !== -1) {
        sub.textContent = sub.textContent.replace(/₹1000/g, t.m2Label);
      }
    });
  }

  function init() {
    paintAllFromDom();
    syncScaleFromDom();
    refresh();

    document.addEventListener('cart:updated', function (e) {
      const detail = e.detail;
      if (detail && detail.cart && detail.cart.total_price !== undefined) update(detail.cart);
      else if (detail && detail.total_price !== undefined) update(detail);
      else refresh();
    });

    document.addEventListener('cart:refresh', refresh);
    document.addEventListener('cart:item-added', function (e) {
      const detail = e.detail;
      if (detail && detail.cart && detail.cart.total_price !== undefined) update(detail.cart);
      else if (detail && detail.total_price !== undefined) update(detail);
      else refresh();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.cartData && event.cartData.total_price !== undefined) {
          update(event.cartData);
        } else {
          refresh();
        }
      });
    }

    document.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('#cart-icon-bubble')) {
          setTimeout(paintAllFromDom, 100);
          setTimeout(refresh, 300);
        }
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  return {
    update: update,
    refresh: refresh,
    paintAllFromDom: paintAllFromDom,
    syncScaleFromDom: syncScaleFromDom,
    THRESHOLD: globalM1(),
    M1: globalM1(),
    M2: globalM2(),
  };
})();
